import { ForwardedRef, forwardRef, InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasValidation?: boolean
  isInvalid?: boolean
  large?: boolean
  uiSize?: 'small' | 'default' | 'large'
}

const Input = forwardRef<HTMLInputElement, InputProps>(function (
  {
    disabled,
    large,
    uiSize = 'default',
    hasValidation,
    className,
    isInvalid,
    ...props
  },
  ref: ForwardedRef<HTMLInputElement>
) {
  large = large || uiSize === 'large'
  const small = !large && uiSize === 'small'

  return (
    <input
      className={`
    ${className ? `${className}` : ''}
    ${hasValidation ? 'tw-mb-0' : 'tw-mb-4'}
    tw-block
    tw-border
    tw-border-solid
    ${!isInvalid ? 'tw-border-system-grey-300' : 'tw-border-red-300'}
    tw-w-full
    ${large ? 'tw-py-3' : 'tw-py-1'}
    ${small ? 'tw-text-sm' : ''}
    ${small ? 'tw-px-0' : 'tw-px-2'}
    tw-rounded
    tw-shadow
    focus:tw-outline-none
    focus:tw-ring
    ${
      disabled
        ? 'hover:tw-cursor-not-allowed tw-text-system-grey-400 tw-bg-white'
        : 'hover:tw-border-system-grey-400'
    }`}
      disabled={disabled}
      {...props}
      ref={ref}
    />
  )
})

export default Input
